import { SEO } from "@/components/SEO";
import { PhoneHero } from "@/components/phonerepair/PhoneHero";
import { AppleDevicesGrid } from "@/components/phonerepair/AppleDevicesGrid";
import { AdvantagesBar } from "@/components/phonerepair/AdvantagesBar";
import { ApplePricingTables } from "@/components/phonerepair/ApplePricingTables";
import { MacSection } from "@/components/phonerepair/MacSection";
import { OtherBrandsSection } from "@/components/phonerepair/OtherBrandsSection";
import { RepairServicesGrid } from "@/components/phonerepair/RepairServicesGrid";
import { PhoneQuoteSection } from "@/components/phonerepair/PhoneQuoteSection";
import { PhoneFAQSection } from "@/components/phonerepair/PhoneFAQSection";

const phoneRepairSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  name: "Réparation Téléphone, iPhone et Tablette à Niort",
  serviceType: "Réparation smartphone et tablette",
  provider: {
    "@type": "LocalBusiness",
    name: "Mediastore Niort",
    address: {
      "@type": "PostalAddress",
      streetAddress: "104 Rue de la Gare",
      addressLocality: "Niort",
      postalCode: "79000",
      addressCountry: "FR",
    },
    telephone: "+33549057490",
  },
  areaServed: { "@type": "City", name: "Niort" },
  description:
    "Réparation iPhone, iPad, Samsung, Huawei, Xiaomi, OnePlus à Niort. Techniciens certifiés Apple. Écran cassé, batterie, connecteur, désoxydation. Réparation express dès 30 min.",
  offers: {
    "@type": "AggregateOffer",
    priceCurrency: "EUR",
    lowPrice: "47",
    highPrice: "359",
    offerCount: "30",
  },
};

export default function PhoneRepairPage() {
  return (
    <div className="min-h-screen" data-testid="phone-repair-page">
      <SEO
        title="Réparation iPhone, Apple, Téléphone & Tablette à Niort - Toutes Marques"
        description="Réparation iPhone, iPad, MacBook, Samsung, Huawei, Xiaomi à Niort. Techniciens certifiés Apple. Écran cassé, batterie, connecteur, désoxydation. Diagnostic gratuit, réparation express dès 30 min, garantie 6 mois."
        keywords="réparation iPhone Niort, réparation iPad Niort, réparation MacBook Niort, écran cassé iPhone Niort, batterie iPhone Niort, réparation Samsung Niort, réparation Huawei Niort, réparation Xiaomi Niort, réparation OnePlus Niort, réparation Google Pixel Niort, réparation tablette Niort, désoxydation téléphone Niort, spécialiste Apple Niort, techniciens certifiés Apple, réparation mobile Niort, réparation smartphone Niort"
        path="/reparation-telephone"
        schema={phoneRepairSchema}
        breadcrumbs={[
          { name: "Accueil", path: "/" },
          { name: "Réparation Téléphone", path: "/reparation-telephone" },
        ]}
      />
      <PhoneHero />
      <AppleDevicesGrid />
      <AdvantagesBar />
      <ApplePricingTables />
      <MacSection />
      <OtherBrandsSection />
      <RepairServicesGrid />
      <PhoneQuoteSection />
      <PhoneFAQSection />
    </div>
  );
}
